import { Injectable } from '@angular/core';
import { tap, mapTo } from 'rxjs/operators';
import { ApiService } from '../shared/services/core/api.service';
import { of, Observable } from 'rxjs';
import { CardStore } from './card.store';
import { CardQuery } from './card.query';
import { Card } from './models/card.model';

@Injectable({ providedIn: 'root' })
export class CardService {
  constructor(
    private cardStore: CardStore,
    private cardQuery: CardQuery,
    private api: ApiService,
  ) {}



  /** Fetches the Cards and puts them in the store. */
  fetchCards(): Observable<null> {
    this.cardStore.setLoading(true);
    const request$: Observable<null> = this.api.get<Card>('cards').pipe(
      tap(cards => this.cardStore.set(cards)),
      mapTo(null)
    );

    return this.cardQuery.getHasCache() ? of(null) : request$;
  }
}
